import Vue from "vue";
import VueI18n, { Locale } from "vue-i18n";
import messages from "@/i18n/pl.i18n";
import { I18nStorageService } from "@/services/i18n-storage.service";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: "pl",
  fallbackLocale: "pl",
  messages
});
const loadedLanguages: Locale[] = ["pl"];

function setI18nLanguage(language: Locale): Locale {
  i18n.locale = language;
  document.querySelector("html")?.setAttribute("lang", language);
  return language;
}

export function loadLanguage(language: Locale): Promise<Locale> {
  if (i18n.locale === language || loadedLanguages.includes(language)) {
    // Language is the same as already set or it is already loaded
    return Promise.resolve(setI18nLanguage(language));
  }

  return import(
    /* webpackChunkName: "[request]" */ `@/i18n/${language}.i18n.ts`
  ).then(messages => {
    i18n.setLocaleMessage(language, messages.default[language]);
    loadedLanguages.push(language);
    return setI18nLanguage(language);
  });
}

if (I18nStorageService.locale) {
  loadLanguage(I18nStorageService.locale);
} else {
  I18nStorageService.saveLocale("pl");
}

export default i18n;
